<div class="checkbox-group-container">
  <div class="content">
    <div class="checkbox" *ngFor="let box of boxes$ | async">
      <div
        class="box"
        [ngClass]="box.checked ? 'selected' : ''"
        (click)="toggleBox(box)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          *ngIf="box.checked"
        >
          <path
            fill="#FFF"
            fill-rule="evenodd"
            d="M10.39 13.097L2.582 5.493 7.436 0.64 9.04 2.182 5.671 5.493 11.875 11.555z"
            transform="rotate(-90 7.229 6.869)"
          />
        </svg>
      </div>
      <div
        class="label"
        *ngIf="box.titleAsHtml; else normal"
        [innerHTML]="box.title"
      ></div>
      <ng-template #normal>
        <div class="label" *ngIf="!box.isLink; else isLInk">
          {{ box.title }}
        </div>
      </ng-template>
      <ng-template #isLInk>
        <a [customRouterLink]="box.linkRef" class="label">
          {{ box.title }}
        </a>
      </ng-template>
      <div class="error" *ngIf="error">
        {{ error }}
      </div>
    </div>
  </div>
</div>
